/**
 * WHEN THE "FOUND N FACTS" LINE COMES OFF THE SCREEN (batch 2d, 28 Sep 2026).
 *
 * THE DEFECT. After a read, the card said "3 facts ready for you to check
 * below", and it still said so after all three were approved and the list
 * beneath it read "Nothing waiting". Two parts of one screen disagreeing is a
 * screen the owner cannot trust, whichever part is right.
 *
 * THE RULE. The line stays while the facts it announced are being worked
 * through — it carries the honesty notes too (left out, already known, part
 * unread), which he should be able to read until he is done — and comes off
 * when the list empties. "Empties" means empty AFTER it was seen holding
 * them, never merely empty: the list is re-fetched a moment after a read, and
 * at that moment it still shows the old count, often zero. Clearing on that
 * zero would take the line down before he had read it.
 *
 * A read that found nothing ("Nothing new to add") never watches the list:
 * the list will not change, and that line has nothing to go stale.
 *
 * Pure, so it is tested plainly (tests/intake-summary.test.ts) rather than
 * through a rendered screen.
 */

export type SummaryWatch = 'none' | 'waiting' | 'seen'

export interface SummaryState {
  summary: string | null
  watch: SummaryWatch
}

export const NO_SUMMARY: SummaryState = { summary: null, watch: 'none' }

/** A read finished: show what it found, and watch the list only if it added to it. */
export function summaryAfterRead(summary: string, proposed: number): SummaryState {
  return { summary, watch: proposed > 0 ? 'waiting' : 'none' }
}

/** The review list changed size. `count` is null while it is still loading. */
export function summaryAfterQueue(state: SummaryState, count: number | null): SummaryState {
  if (count === null) return state
  if (state.watch === 'waiting' && count > 0) return { ...state, watch: 'seen' }
  if (state.watch === 'seen' && count === 0) return NO_SUMMARY
  return state
}
